module.exports = __webpack_public_path__ + "img/IT0004847230518.6d97ccdc.png";